import { NgControl } from '@angular/forms';
import { Directive, HostListener, inject } from '@angular/core';

/**
 * A directive that automatically converts the input text to lowercase.
 * This directive listens to input events on the host element and transforms
 * the input value to lowercase before updating the control's value.
 */
@Directive({
	selector: '[appToLowercase]'
})
export class ToLowercaseDirective {
	private readonly ngControl = inject(NgControl);

	@HostListener('input', ['$event'])
	onInput(event: Event): void {
		const value = (event.target as HTMLInputElement).value;
		if (value) {
			this.ngControl.control?.setValue(value.toLowerCase(), { emitEvent: false });
		}
	}
}

